/**
 * CUSTOMERS
 */
// actions
export const GET_CUSTOMERS = 'GET_CUSTOMERS';
export const DELETE_CUSTOMERS = 'DELETE_CUSTOMERS';
export const GET_CUSTOMER = 'GET_CUSTOMER';
export const ADD_CUSTOMER = 'ADD_CUSTOMER';
export const STORE_CUSTOMER = 'STORE_CUSTOMER';
export const EDIT_CUSTOMER = 'EDIT_CUSTOMER';
export const SEARCH_CUSTOMERS = 'SEARCH_CUSTOMERS';

export const ADD_CUSTOMER_ADDRESS = 'ADD_CUSTOMER_ADDRESS';
export const EDIT_CUSTOMER_ADDRESS = 'EDIT_CUSTOMER_ADDRESS';
export const DELETE_CUSTOMER_ADDRESS = 'DELETE_CUSTOMER_ADDRESS';

// actions & mutations
export const STORE_CUSTOMERS = 'STORE_CUSTOMERS';
export const CLEAR_CUSTOMERS = 'CLEAR_CUSTOMERS';
export const SELECT_CUSTOMER = 'SELECT_CUSTOMER';
export const SELECT_ALL_CUSTOMERS = 'SELECT_ALL_CUSTOMERS';

export const CLEAR_CUSTOMER_FROM_STORE = 'CLEAR_CUSTOMER_FROM_STORE';

export const STORE_ALLSHIPMENT_SEARCH_QUERY = 'STORE_ALLSHIPMENT_SEARCH_QUERY';
